<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <CustomerService></CustomerService>
    <GoTop></GoTop>
  </div>
</template>

<script>
import CustomerService from '@/components/CustomerService'
export default {
  name: 'App',
  components: {
    CustomerService
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue